'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var OutlinedInput = _interopDefault(require('@material-ui/core/OutlinedInput'));
var InputLabel = _interopDefault(require('@material-ui/core/InputLabel'));
var highlight = require('../utils/highlight.js');

var Label = styled__default(InputLabel)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  margin: 1rem 0 0.5rem 1px;\n"], ["\n  margin: 1rem 0 0.5rem 1px;\n"])));
var ResizeArea = function (_a) {
    var resize = _a.resize, rest = tslib.__rest(_a, ["resize"]);
    return (React__default.createElement(OutlinedInput, tslib.__assign({}, rest)) // eslint-disable-line react/jsx-props-no-spreading
    );
};
var Textarea = styled__default(ResizeArea)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  padding: 0;\n  box-sizing: border-box;\n  border-radius: 6px;\n  background-color: #ffffff;\n  .MuiInputBase-input {\n    font-size: 0.9rem;\n  }\n  .MuiInputBase-inputMultiline {\n    padding: 9px 13px;\n    resize: ", ";\n  }\n"], ["\n  padding: 0;\n  box-sizing: border-box;\n  border-radius: 6px;\n  background-color: #ffffff;\n  .MuiInputBase-input {\n    font-size: 0.9rem;\n  }\n  .MuiInputBase-inputMultiline {\n    padding: 9px 13px;\n    resize: ", ";\n  }\n"])), function (_a) {
    var resize = _a.resize;
    return resize;
});
var Main = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), highlight.outlined);
var templateObject_1, templateObject_2, templateObject_3;

exports.Label = Label;
exports.Main = Main;
exports.Textarea = Textarea;
